
export const getLatestPosts = state => state.blog.posts.list;

export const getTotalPosts = state => state.blog.posts.total;

export const getFeaturedPosts = state => state.blog.featured;

export const getPinnedPosts = state => state.blog.pinned;

export const getLoadedPost = state => state.blog.post;
